import { IconTextUnit as CommonIconTextUnit, type IconTextUnitProps } from '@monorepo/common';

function IconTextUnit({ text, imgSrc, unit, textSize, isUnitBold, 'data-testid': dataTestId }: IconTextUnitProps) {
  return (
    <CommonIconTextUnit
      text={text}
      imgSrc={imgSrc}
      unit={unit}
      textSize={textSize}
      isUnitBold={isUnitBold}
      data-testid={dataTestId}
    />
  );
}

export default IconTextUnit;
